import { createSvgIcon } from '@mui/material/utils';
import { AllianceAppKey } from './alliance-apps';

/**
 * Custom app glyphs for the App Launcher tiles, the Sign In eyebrow and the
 * System Screens. 24×24 grid, 2px round stroke, currentColor, no fills, so
 * they sit next to MUI's filled icons without copying them.
 *
 * The favicons in public/ are the same glyphs with a thicker stroke.
 */
const strokeIcon = (paths: string[], displayName: string) =>
  createSvgIcon(
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </g>,
    displayName,
  );

/** A speedometer: ARC is where agents check how they are performing */
export const ArcIcon = strokeIcon(
  [
    'M3.34 19A10 10 0 1 1 20.66 19',
    'M12 14l4.5-5',
    'M10.5 14a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0',
    'M12 5v1.5',
    'M5.6 7.6l1 1',
    'M18.4 7.6l-1 1',
    'M3 14h1.5',
    'M19.5 14H21',
  ],
  'ArcIcon',
);

/** A contract page with a folded corner and a signature stroke */
const ContractingIcon = strokeIcon(
  [
    'M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z',
    'M14 3v4h4',
    'M9 16c1-1.5 1.7 1.5 2.6 0s1.7 1.5 2.4 0',
  ],
  'ContractingIcon',
);

/** A folded map, for the lead maps used throughout Leads */
const LeadsIcon = strokeIcon(
  ['M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z', 'M9 3v15', 'M15 6v15'],
  'LeadsIcon',
);

/** A ticket stub with notched sides and a tear line */
const EventsIcon = strokeIcon(
  [
    'M4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a2 2 0 0 0 0 4v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a2 2 0 0 0 0-4z',
    'M14 6v2',
    'M14 11v2',
    'M14 16v2',
  ],
  'EventsIcon',
);

/** A mortarboard with a tassel: training and courses */
const UniversityIcon = strokeIcon(
  ['M2 9l10-5 10 5-10 5z', 'M6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5', 'M22 9v5'],
  'UniversityIcon',
);

/** Look up an app's glyph by key */
export const APP_ICONS: Record<AllianceAppKey, typeof ArcIcon> = {
  arc: ArcIcon,
  contracting: ContractingIcon,
  leads: LeadsIcon,
  events: EventsIcon,
  university: UniversityIcon,
};
